import { MentionChip } from "@circle-react-shared/EditorContentBlocks/MentionChip";

import type { Mention } from "./types";

interface MentionLinkProps {
  mention: Mention;
}

export const MentionLink = ({ mention }: MentionLinkProps) => (
  <MentionChip name={mention.name} />
);
